import React, { useEffect, useRef, useState } from "react";

import httpService from "../../services/httpService";
import { useOutletContext, useNavigate } from "react-router-dom";

import { Contact } from "./Contact";
import useAbortController from "V2.0/hooks/useAbortController";

function getContacts({ projectId }) {
  return httpService.get(`/contact/whitelabelGetContacts/${projectId}`);
}

function getContact({ projectId, contactId }) {
  return httpService.get(
    `/contact/whitelabelGetContact/${projectId}/${contactId}`
  );
}

function createContact({ projectId, payload }) {
  return httpService.post(
    `/contact/whitelabelCreateContact/${projectId}`,
    payload
  );
}

function updateContact({ projectId, contactId, payload }) {
  return httpService.put(
    `/contact/whitelabelEditContact/${projectId}/${contactId}`,
    payload
  );
}

function deleteContact({ projectId, contactId }) {
  return httpService.delete(
    `/contact/whitelabelDeleteContact/${projectId}/${contactId}`
  );
}

function getContactsPaginated(workspaceId, params, signal) {
  return httpService.get(
    `/contact/whitelabelGetContactsPaginated/${workspaceId}`,
    { params, signal }
  );
}

export {
  getContact,
  getContacts,
  createContact,
  updateContact,
  deleteContact,
  getContactsPaginated,
};

export function Contacts(props) {
  const { projectId, isViewOnly } = useOutletContext();

  const [contacts, setContacts] = useState({
    contacts: [],
    currentPage: 1,
    totalContacts: 0,
    pageSize: 50,
    isLoading: true,
    isViewOnly
  });
  const { controllerRef, resetController } = useAbortController();

  const setLoading = (loading) => {
    setContacts((prevState) => {
      return {
        ...prevState,
        loading,
      };
    });
  };

  const fetchContacts = async (
    workspaceId,
    page = 1,
    pageSize = 50,
    isLoading = false,
    searchTerm = ""
  ) => {
    const controller = resetController();

    setLoading(isLoading);
    try {
      const response = await getContactsPaginated(workspaceId, {
        page,
        pageSize,
        searchTerm
      }, controller.signal);
      if (response.status === 200) {
        const data = response.data;
        if (Array.isArray(data)) {
          setContacts({
            contacts: data,
            currentPage: 1,
            totalPages: 1,
            pageSize: data.length,
            totalContacts: data.length,
            isLoading: false,
          });
        } else {
          setContacts({
            ...response.data,
            isLoading: false,
          });
        }
      }
    } catch (error) {
      setLoading(false);
      console.error(error);
    }
  };

  useEffect(() => {
    if (projectId) {
      fetchContacts(projectId, 1, 50, true);
    }

    return () => {
      setContacts({
        contacts: [],
        currentPage: 1,
        totalContacts: 0,
        pageSize: 50,
        isLoading: true,
      });
    };
  }, [projectId]);

  return (
    <Contact
      contacts={contacts}
      fetchContacts={fetchContacts}
      projectId={projectId}
      isViewOnly={isViewOnly}
    />
  );
}
